import { GenIcon } from 'react-icons'

const CmAlcohol = GenIcon({
  tag: 'svg',
  attr: { viewBox: '0 0 10 11' },
  child: [
    {
      tag: 'path',
      attr: {
        d: 'M9.625 2.79167V1.875H1.375V2.79167L5.04167 6.91667V9.20833H2.75V10.125H8.25V9.20833H5.95833V6.91667L9.625 2.79167ZM3.40542 3.70833L2.59417 2.79167H8.41042L7.59458 3.70833H3.40542Z',
        fill: 'black'
      },
      child: []
    }
  ]
})

export default CmAlcohol
